;(function() {
  'use strict'
  angular
    .module('glow.reporting')
    .component('surveyExplorerExportViewsDialog', {
      controller: Controller,
      templateUrl: 'survey-explorer-export-views-dialog.html',
      bindings: {
        format: '@',
        modes: '<',
        onExport: '&',
        onCancel: '&',
      },
    })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.select = select
    ctrl.apply = apply
    ctrl.cancel = cancel

    var MODE_ORDER = ['all', 'current', 'selected']
    var MODE_LABELS = {
      all: 'All views',
      current: 'Current view',
      selected: 'Selected views',
    }

    function onInit() {
      var isPptx = ctrl.format === 'pptx'
      ctrl.title = isPptx ? 'Export to PowerPoint' : 'Export to Workbook'

      ctrl.options = MODE_ORDER.map(function(value) {
        var mode = ctrl.modes[value]
        var disabled = mode.count === 0 || (isPptx && !mode.compatible)
        return {
          value: value,
          label: MODE_LABELS[value],
          subText: getSubText(value, mode, disabled, isPptx),
          disabled: disabled,
        }
      })

      var firstEnabled = ctrl.options.find(function(option) {
        return !option.disabled
      })
      ctrl.selected = firstEnabled ? firstEnabled.value : null
    }

    function getSubText(value, mode, disabled, isPptx) {
      if (value === 'current') {
        if (!disabled) return mode.label
        return isPptx
          ? "This view can't be exported to PowerPoint"
          : "This view can't be exported"
      }
      if (value === 'selected' && mode.count === 0) {
        return 'Select views first'
      }
      return mode.count + (mode.count === 1 ? ' view' : ' views')
    }

    function select(value) {
      ctrl.selected = value
    }

    function apply() {
      if (!ctrl.selected) return
      ctrl.onExport({ $mode: ctrl.selected })
    }

    function cancel() {
      ctrl.onCancel()
    }
  }
})()
